import { NetworkType } from 'app/plugins/openstack/components/networks/constants'
import { listZones } from 'app/plugins/openstack/components/networks/dns/zones/actions'
import { zonesSelector } from 'app/plugins/openstack/components/networks/dns/zones/selectors'
import { useAppSelector } from 'app/store'
import AsyncDropdown from 'core/elements/dropdown/AsyncDropdown'
import useListAction from 'core/hooks/useListAction'
import React from 'react'

const ZonePicklist = ({ setLabelAsValue = false, ...props }) => {
  const { loading } = useListAction(listZones)
  const data = useAppSelector(zonesSelector)

  const primaryZones =
    data?.filter(
      (zone) =>
        zone?.type !== NetworkType.SECONDARY &&
        zone?.status?.status !== 'ERROR' &&
        zone?.status?.action !== 'DELETE',
    ) || []

  const items = primaryZones?.length
    ? [
        { label: 'None', value: '' },
        ...primaryZones.map(({ name, backend, id }) => {
          const label = `${name}${backend ? ` (${backend})` : ''}`
          return setLabelAsValue
            ? { label, value: label?.toLowerCase() || '' }
            : { label, value: id }
        }),
      ]
    : [{ label: 'No DNS Zone Available', value: '' }]

  return (
    <AsyncDropdown
      label="DNS Zone"
      loading={loading}
      items={items}
      {...props}
      disabled={!primaryZones?.length}
    />
  )
}

export default ZonePicklist
